// extracted by mini-css-extract-plugin
module.exports = {"opeartions":"index_opeartions__1HWFE"};